/**
 * Map config_event.calendar_first_day (1=Mon … 7=Sun) to moment.js dow (0=Sun … 6=Sat).
 */
export const mapCalendarFirstDayToMoment = (calendarFirstDay) => {
  const map = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 0,
  };

  return map[calendarFirstDay] ?? 0;
};

/**
 * Map config_event.calendar_default_view to calendar component view id.
 */
export const mapCalendarDefaultView = (view) => {
  const map = {
    monthly: "month",
    weekly: "week",
    daily: "day",
  };

  return map[view] || "month";
};

export const isTwentyFourHourFormat = (timeFormat) =>
  String(timeFormat) === "24";

export const formatCalendarHourLabel = (hour, timeFormat) => {
  if (isTwentyFourHourFormat(timeFormat)) {
    return { hour: String(hour).padStart(2, "0"), suffix: "" };
  }

  if (hour === 0 || hour === 24) {
    return { hour: "12", suffix: "am" };
  }

  if (hour === 12) {
    return { hour: "12", suffix: "pm" };
  }

  if (hour < 12) {
    return { hour: String(hour), suffix: "am" };
  }

  return { hour: String(hour - 12), suffix: "pm" };
};

export const mapDatePickerFormatToMoment = (format) => {
  const map = {
    "mm-dd-yyyy": "MM-DD-YYYY",
    "mm/dd/yyyy": "MM/DD/YYYY",
    "yyyy/mm/dd": "YYYY/MM/DD",
  };

  return map[format] || "MM/DD/YYYY";
};

/**
 * Map config_event.calendar_first_day to react-calendar calendarType.
 * react-calendar v3 supports US (Sun), ISO 8601 (Mon), and Arabic (Sat) only.
 */
export const mapCalendarFirstDayToReactCalendarType = (calendarFirstDay) => {
  const map = {
    1: "ISO 8601",
    2: "ISO 8601",
    3: "ISO 8601",
    4: "ISO 8601",
    5: "ISO 8601",
    6: "Arabic",
    7: "US",
    "1": "ISO 8601",
    "2": "ISO 8601",
    "3": "ISO 8601",
    "4": "ISO 8601",
    "5": "ISO 8601",
    "6": "Arabic",
    "7": "US",
  };

  return map[calendarFirstDay] || "ISO 8601";
};

export const PRESET_EVENT_DURATIONS = ["5", "10", "15", "30", "45", "60"];

export const isPresetEventDuration = (minutes) =>
  PRESET_EVENT_DURATIONS.includes(String(minutes));
